import path from 'path';
import fs from 'fs';
import dayjs from 'dayjs';
import { IS_PRIVATE } from '@/common/constant/platform';
import { getUrlQuery } from '@/common/tools';
import store from '@/renderer/store';
const mkdir = {
  mkdirDeepSync(dirPath: string): any {
    const DirPath = path.resolve(dirPath);
    let stats = null;
    try {
      stats = fs.statSync(DirPath);
    } catch (err: any) {
      if (err.code === 'EPERM') return err;
    }
    let error;
    if (stats) {
      if (!stats.isDirectory()) {
        return `exist_same_file ${DirPath} ${path.sep}`; // 创建文件夹时发现存在同名的文件
      }
    } else {
      error = mkdir.mkdirDeepSync(path.dirname(DirPath));
      if (error) return error; // 创建父文件夹错误
      try {
        fs.mkdirSync(DirPath);
      } catch (e) {
        error = e;
        return error; // 创建文件夹错误
      }
    }

    return error;
  },
};
export default mkdir;

/**
 * @description 私有化环境中根据url上的信息判断超时
 * @export
 * @param {string} url
 * @param {string} responseDate
 * @return {*}  {boolean}
 */
export function isExpiredInPrivate(url: string, responseDate?: string): boolean {
  if (!IS_PRIVATE || !responseDate) return false;
  const { query = {} } = getUrlQuery(url);
  const amzDate = query['X-Amz-Date'];
  if (!amzDate) return false;
  let starttime = dayjs(responseDate).valueOf();
  if (dayjs(query['X-Amz-Date']).isValid()) {
    starttime = dayjs(query['X-Amz-Date']).valueOf();
  } else {
    let [time1, time2] = amzDate.split('T');
    time1 = dayjs(time1).format('YYYY-MM-DD');
    time2 = time2.replace(/\B(?=(\d{2})+(?!\d))/g, ':');
    starttime = dayjs([time1, time2].join('T')).valueOf();
  }
  const expires = query['X-Amz-Expires'];
  const expirationTime = starttime + Number(expires);
  const currtime = dayjs(responseDate).valueOf();
  const expireOffset = 5 * 3600; // 有效期到5分钟以内都算超时
  return currtime + expireOffset > expirationTime;
}

/**
 * 打开a标签下载文件
 * @param url
 * @param fileName
 * @param newWin
 */
export const openATagToDownloadUrl = (url: string, fileName: string, newWin?: boolean) => {
  const a = document.createElement('a');
  a.download = fileName;
  a.href = url;
  // 会议里补充后缀
  if (store.getters.isInWeMeetApp) {
    a.href += '&pf=meeting';
  }
  if ((!store.getters.isMobile && newWin) || store.getters.isInWeMeetApp) {
    a.target = '_blank';
  }
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

/**
 * 打开a标签下载文件
 * @param url
 * @param fileName
 * @param newWin
 */
export const downloadByATag = (url: string | object, params?: { fileName?: string; newWin?: boolean }) => {
  const { fileName = '', newWin = false } = params || {};
  let downloadUrl = '';
  if (typeof url === 'object' && url instanceof Blob) {
    downloadUrl = URL.createObjectURL(url); // 创建blob地址
  } else if (typeof url === 'string') {
    downloadUrl = url;
    const attachmentParam = 'response-content-disposition=';
    const hasAttachmentParam = downloadUrl.includes(attachmentParam);
    if (!hasAttachmentParam && fileName) {
      const separator = downloadUrl.includes('?') ? '&' : '?';
      // 通过`attachment; filename=`解决fileName重命名问题
      const contentDisposition = encodeURIComponent(`attachment; filename="${encodeURIComponent(fileName)}"`);
      downloadUrl = downloadUrl + separator + attachmentParam + contentDisposition;
    }
    if (store.getters.isInWeMeetApp) {
      downloadUrl += '&pf=meeting';
    }
  }
  const a = document.createElement('a');
  a.download = fileName;
  a.href = downloadUrl;
  if ((!store.getters.isMobile && newWin) || store.getters.isInWeMeetApp) {
    a.target = '_blank';
  }
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  if (typeof url === 'object' && url instanceof Blob) {
    URL.revokeObjectURL(downloadUrl);
  }
};
